Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.useScrollViewOffset = useScrollViewOffset;
var _react = require("react");
var _reactNative = require("react-native");
var _utils = require("./utils");
var _useSharedValue = require("./useSharedValue");
var scrollEventNames = [
    "onScroll",
    "onScrollBeginDrag",
    "onScrollEndDrag",
    "onMomentumScrollBegin",
    "onMomentumScrollEnd"
];
var _worklet_7096777976604_init_data = {
    code: "function anonymous(event){const{offsetRef}=this.__closure;offsetRef.current.value=event.contentOffset.x===0?event.contentOffset.y:event.contentOffset.x;}",
    location: "/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/hook/useScrollViewOffset.ts",
    sourceMap: '{"version":3,"names":["anonymous","event","offsetRef","__closure","current","value","contentOffset","x","y"],"sources":["/vercel/path0/example/node_modules/react-native-reanimated/src/reanimated2/hook/useScrollViewOffset.ts"],"mappings":"AA0BsC,QAAC,CAAAA,SAAuBA,CAAAC,KAAA,QAAAC,SAAA,OAAAC,SAAA,CAE1DD,SAAS,CAACE,OAAO,CAACC,KAAK,CACrBJ,KAAK,CAACK,aAAa,CAACC,CAAC,GAAK,CAAC,CACvBN,KAAK,CAACK,aAAa,CAACE,CAAC,CACrBP,KAAK,CAACK,aAAa,CAACC,CAAC,CAC7B"}',
    version: "3.5.4"
};
function useScrollViewOffset(aref, initialRef) {
    var offsetRef = (0, _react.useRef)(initialRef !== undefined ? initialRef : (0, _useSharedValue.useSharedValue)(0));
    var event = (0, _utils.useEvent)(function() {
        var _e = [
            new global.Error(),
            -2,
            -27
        ];
        var anonymous = function anonymous(event) {
            offsetRef.current.value = event.contentOffset.x === 0 ? event.contentOffset.y : event.contentOffset.x;
        };
        anonymous.__closure = {
            offsetRef: offsetRef
        };
        anonymous.__initData = _worklet_7096777976604_init_data;
        anonymous.__workletHash = 7096777976604;
        anonymous.__stackDetails = _e;
        return anonymous;
    }(), scrollEventNames);
    (0, _react.useEffect)(function() {
        var _event$current;
        var viewTag = (0, _reactNative.findNodeHandle)(aref.current);
        (_event$current = event.current) == null ? void 0 : _event$current.registerForEvents(viewTag);
    }, [
        aref.current
    ]);
    return offsetRef.current;
}
